var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 3V0H9V7H16V3ZM15 1V2H12V1H15ZM11 1V3H13V4H10V1H11ZM10 6V5H14V3H15V6H10ZM7 0H0V7H7V0ZM6 4H5.67C4.19631 3.9978 3.0022 2.80369 3 1.33V1H6V4ZM1 6V5H1.561C1.80322 5.00055 1.99945 5.19677 2 5.439V6H1ZM3 6V5.439C2.99945 4.64449 2.35551 4.00055 1.561 4H1V1H2V1.33C2.00275 3.35574 3.64426 4.99725 5.67 5H6V6H3ZM16 9H9V16H16V9ZM10 15V12H13V13H12V14H13V15H10ZM15 15H14V12H15V15ZM15 11H10V10H15V11ZM7 9H0V16H7V9ZM6 10V13.09C5.895 13.1071 5.79032 13.1261 5.686 13.147C5.66809 13.1074 5.65109 13.0674 5.635 13.027C5.49095 12.6333 5.26884 12.2727 4.982 11.967C4.109 11.095 3.802 10.874 3.005 10.874C2.21991 11.0032 1.5079 11.4116 1 12.024V10H6ZM1 15V13.568L1.11 13.419C1.54996 12.7056 2.21757 12.1613 3.005 11.874C3.402 11.874 3.475 11.874 4.275 12.674C4.46829 12.8902 4.61712 13.1423 4.713 13.416C4.825 13.681 5.041 14.196 5.52 14.196C5.60328 14.1949 5.6859 14.1811 5.765 14.155C5.778 14.15 5.844 14.134 6 14.105V15H1Z",
    fill: "#6A6A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapBase);
export default __webpack_public_path__ + "static/media/MapBase.b57cbe2f4473a28ae3e7289cdb668833.svg";
export { ForwardRef as ReactComponent };